import {subCategoryObject} from "@/content/services/1";
import ServiceSubCategoryPage from "@/ui/widgets/service-subcategory-page";

export default function Category1Service4Page() {
    const { category1Service4: subCategory } = subCategoryObject;
    return (<ServiceSubCategoryPage subCategory={subCategory}   />)
}
